// JsFromRoutes CacheKey 5749ca89310b19f1f78743586befb867
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/events/:external_id/visits'),
}
